<template>
    <div>
        <div v-for="(item, index) in items" :key="index">
            <router-link
                v-if="item.isLink"
                :to="{
                    name: 'item',
                    params: {
                        id: item.encodedId
                    }
                }"
            >
                {{ item.label }}
            </router-link>
            <span v-else>{{ item.label }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        record: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            items: []
        };
    },
    mounted() {
        const record = this.record;

        if (record.module === "onprem") {
            if (record.analyzerType) {
                this.items.push({
                    isLink: false,
                    label: record.source + ": " + record.analyzerType
                });
                return;
            }

            if (Object.keys(record.test).length > 0) {
                this.itemEncodedId = record.test.item.encodedId;
                this.items.push({
                    isLink: true,
                    label: record.test.name,
                    encodedId: record.test.item.encodedId
                });
                return;
            }
        }

        if (["abaxis_api", "abaxis_fuse"].includes(record.module)) {
            if (record.test && Object.keys(record.test).length > 0) {
                if (record.test.encodedId) {
                    this.items.push({
                        isLink: true,
                        label: record.test.name,
                        encodedId: record.test.encodedId
                    });
                } else {
                    this.items.push({
                        isLink: false,
                        label: record.test.name
                    });
                }
                return;
            }
        }

        if (record.module === "lab") {
            if (record.result && record.result.item) {
                if (record.result.item.encodedId) {
                    this.items.push({
                        isLink: true,
                        label: record.result.item.name,
                        encodedId: record.result.item.encodedId
                    });
                } else {
                    this.items.push({
                        isLink: false,
                        label: record.result.item.name
                    });
                }
                return;
            } else if (Object.keys(record.result).length > 0) {
                let provider = record.reference_type.replace(/_/g, " ");
                let label = "";

                provider = provider
                    .toLowerCase()
                    .replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });

                if (record.result_reference_id != null) {
                    label =
                        provider +
                        ": " +
                        record.result.name +
                        " #" +
                        record.result_reference_id;
                } else {
                    label = provider + ": " + record.result.name;
                }

                this.items.push({
                    label,
                    isLink: false
                });
                return;
            }
        }

        if (
            [
                "idexx",
                "znlabs",
                "midwest",
                "nbiovet",
                "vetek",
                "microvet",
                "bionote",
                "heska",
                "abaxis",
                "heska_cloud"
            ].includes(record.module)
        ) {
            if (
                Object.keys(record.test).length > 0 &&
                Array.isArray(record.test)
            ) {
                for (let value of record.test) {
                    if (value.item) {
                        if (value.item.name) {
                            this.items.push({
                                label: value.item.name,
                                isLink: true,
                                encodedId: value.item.encodedId
                            });
                        } else if (value.item.master_name) {
                            this.items.push({
                                label: value.item.master_name,
                                isLink: false
                            });
                        } else if (value.item.code_name) {
                            this.items.push({
                                label: value.item.code_name,
                                isLink: false
                            });
                        }
                    }
                }

                return;
            } else if (
                record.test &&
                record.test.item &&
                record.test.item.item &&
                record.test.item.item.code_name
            ) {
                this.items.push({
                    label: record.test.item.item.code_name,
                    isLink: false
                });
                return;
            }
        }

        if (record.module === "antech") {
            if (record.test && record.test.length > 0) {
                this.items.push({
                    label: record.test,
                    isLink: false
                });
            }
            return;
        }
    }
};
</script>
